import { render, staticRenderFns } from "./RoomTypeInfo.vue?vue&type=template&id=b8aa4c70&"
import script from "./RoomTypeInfo.vue?vue&type=script&lang=js&"
export * from "./RoomTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports